import"../../chunk-LO54M23N.mjs";import{useEffect as t,useRef as u}from"react";const n=r=>{const e=u(void 0);return t(()=>{e.current=r}),e.current};var o=n;export{o as default};
//# sourceMappingURL=usePreviousState.mjs.map